import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import UAParser from 'ua-parser-js';
import Layout from 'qr/components/Layouts';
import { TableTagNamespace } from 'src/shared/enums';

import { Detail } from '../../components/Detail';

import type { DetailEndpoint } from '../../components/Detail';
import type { OS } from 'src/shared/types';

const BaseRestaurant = () => {
    const router = useRouter();
    const [os, setOs] = useState<OS | undefined>(undefined);
    const [isBrowserSafari, setIsBrowserSafari] = useState<boolean>(false);
    const { namespace, id } = router.query;
    let tableId = undefined;

    useEffect(() => {
        const uaParser = new UAParser();
        const browserName = uaParser.getBrowser().name?.toLocaleLowerCase() || '';
        setOs(uaParser.getOS().name?.toLocaleLowerCase() as OS);
        setIsBrowserSafari(!!browserName.match('safari'));
    }, [setOs]);

    if (id === undefined || Array.isArray(id) || namespace === undefined || os === undefined) return null;

    let endpoint: DetailEndpoint = {
        path: '/restaurant/by-id/:restaurantId',
        queryParams: {
            restaurantId: id,
        },
    };

    if (
        namespace === TableTagNamespace.TABLE ||
		namespace === TableTagNamespace.RESTAURANT
    ) {
        endpoint = {
            path: '/restaurant/by-table-tag/:id/:namespace',
            queryParams: {
                id,
                namespace,
            },
        };
        tableId = id;
    }

    /**
     * it could be some brand namespaces
     * for example /~qr/ogn~eso/eiiKphYG8SkBKC6xjDzJia/ redirect to start app
     * for example /~qr/eso/eiiKphYG8SkBKC6xjDzJia/ redirect to start app
    */
    if (/^(.+~)?eso$/.test(namespace as string)) {
        endpoint = {
            path: '/restaurant/by-eshop-order/:id',
            queryParams: {
                id,
            },
        };
    }

    return (
        <Layout>
            <Detail
                endpoint={endpoint}
                isBrowserSafari={isBrowserSafari}
                namespace={namespace as TableTagNamespace}
                os={os}
                tableId={tableId}
            />
        </Layout>
    );
};

export default BaseRestaurant;
